import { render, staticRenderFns } from "./PublishingContractsAgreementNumbersReadOnlyPanel.vue?vue&type=template&id=35700997"
import script from "./PublishingContractsAgreementNumbersReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./PublishingContractsAgreementNumbersReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./PublishingContractsAgreementNumbersReadOnlyPanel.vue?vue&type=style&index=0&id=35700997&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports